import { GoldMaster } from '../references/tenant';
import { BaseService } from './base-service';
import { CacheService } from './cache-service';

const tenantApi = process.env.REACT_APP_TENANT_API || '';

export type Tenant = {
  id: string;
  api: string;
  name: string;
  roles: string;
  systemId: string;
  authentication: string;
  isGoldMaster: string;
};

class TenantService extends BaseService<Tenant> {
  async fetchTenants(): Promise<Tenant[]> {
    return this.apiFetch({ path: '/tenants/all' }) as Promise<Tenant[]>;
  }

  async getTenantAuthUrl(system: string): Promise<string> {
    // const cachedUrl = CacheService.get('pdc.tenant.authentication');
    // if (cachedUrl) {
    //   return cachedUrl;
    // }
    const tenant = await this.fetchTenant(system);
    return tenant.authentication;
  }

  setTenant(tenant: Tenant): void {
    this.cacheTenant(tenant);
  }

  private async fetchTenant(system: string): Promise<Tenant> {
    const result = await fetch(`${tenantApi}/tenants`, { headers: { 'X-Tenant': system } });
    const tenant = await result.json() as Tenant;
    if (!tenant?.id) {
      throw new Error('Tenant not found');
    }
    this.cacheTenant(tenant);
    return tenant;
  }

  private cacheTenant(tenant: Tenant): void {
    for (const key in tenant) {
      if (key === 'id' && tenant.isGoldMaster) {
        localStorage.setItem(`pdc.tenant.${key}`, GoldMaster);
        continue;
      }
      localStorage.setItem(`pdc.tenant.${key}`, tenant[key as keyof Tenant]);
    }
  }

  isGoldMaster(): boolean {
    return CacheService.get('pdc.tenant.id') === GoldMaster;
  }

}

export default new TenantService('/tenants');
